export default "__VITE_ASSET__6e67f100__"